import { z } from "zod";
import { createEndpoint, StandardSuccessResponseSchema } from "../createEndpoint";
import { HttpClient, QueryParams } from "../httpClient";
import {
    AdminCategoryTreeSchema,
    AdminCategoryCreateResponseSchema,
    AdminSubcategoryCreateResponseSchema,
} from "../schemas/service-categories";

export interface CreateCategoryBody {
    name: string;
    group_name: string | null;
}

export interface UpdateCategoryBody {
    name: string;
    group_name: string | null;
}

export interface CreateSubcategoryBody {
    category_id: number;
    name: string;
}

export interface UpdateSubcategoryBody {
    category_id: number;
    name: string;
}

export function createAdminServiceCategoriesApi(http: HttpClient, baseUrl: string) {
    const categoriesBaseUrl = `${baseUrl}/admin/service-categories`;
    const subcategoriesBaseUrl = `${baseUrl}/admin/service-subcategories`;

    return {
        listTree: createEndpoint<
            z.infer<typeof AdminCategoryTreeSchema>
        >(http, "GET", "", {
            base: categoriesBaseUrl,
            responseSchema: AdminCategoryTreeSchema,
        }),

        createCategory: createEndpoint<
            z.infer<typeof AdminCategoryCreateResponseSchema>,
            CreateCategoryBody
        >(http, "POST", "", {
            base: categoriesBaseUrl,
            responseSchema: AdminCategoryCreateResponseSchema,
        }),

        updateCategory: createEndpoint<
            z.infer<typeof AdminCategoryCreateResponseSchema>,
            UpdateCategoryBody,
            QueryParams,
            { categoryId: number | string }
        >(http, "PUT", "/:categoryId", {
            base: categoriesBaseUrl,
            responseSchema: AdminCategoryCreateResponseSchema,
            params: ["categoryId"],
        }),

        deleteCategory: createEndpoint<
            z.infer<typeof StandardSuccessResponseSchema>,
            unknown,
            QueryParams,
            { categoryId: number | string }
        >(http, "DELETE", "/:categoryId", {
            base: categoriesBaseUrl,
            responseSchema: StandardSuccessResponseSchema,
            params: ["categoryId"],
        }),

        createSubcategory: createEndpoint<
            z.infer<typeof AdminSubcategoryCreateResponseSchema>,
            CreateSubcategoryBody
        >(http, "POST", "", {
            base: subcategoriesBaseUrl,
            responseSchema: AdminSubcategoryCreateResponseSchema,
        }),

        updateSubcategory: createEndpoint<
            z.infer<typeof AdminSubcategoryCreateResponseSchema>,
            UpdateSubcategoryBody,
            QueryParams,
            { subcategoryId: number | string }
        >(http, "PUT", "/:subcategoryId", {
            base: subcategoriesBaseUrl,
            responseSchema: AdminSubcategoryCreateResponseSchema,
            params: ["subcategoryId"],
        }),

        deleteSubcategory: createEndpoint<
            z.infer<typeof StandardSuccessResponseSchema>,
            unknown,
            QueryParams,
            { subcategoryId: number | string }
        >(http, "DELETE", "/:subcategoryId", {
            base: subcategoriesBaseUrl,
            responseSchema: StandardSuccessResponseSchema,
            params: ["subcategoryId"],
        }),
    };
}
